import { ROUTE_GROUPS } from '@atlassian/jira-common-constants/src/spa-routes';
import { ff } from '@atlassian/jira-feature-flagging';
import { AsyncKbNav } from '@atlassian/jira-horizontal-nav-jsm-knowledge-base';
import { useHorizontalNavComponent } from '@atlassian/jira-navigation-apps-horizontal-nav-selector';
import { useCurrentRoute } from '@atlassian/jira-platform-router-utils';

export const useIsKBRouteWithHorizontalNav = () => {
	const route = useCurrentRoute();
	const HorizontalNavComponent = useHorizontalNavComponent();

	return (
		ff('jsm-kb-nav-refresh-changes-enabled') &&
		route.group === ROUTE_GROUPS.SERVICEDESK &&
		HorizontalNavComponent === AsyncKbNav
	);
};
